(() => {
  const shirtColors = [
  { name: 'White', hex: '#ffffff' },
  { name: 'Yellow', hex: '#ffe000' },
  { name: 'Navy', hex: '#2e279c' },
  { name: 'Blue', hex: '#1061cf' },
  { name: 'Black', hex: '#111111' },
  { name: 'Green', hex: '#09a83f' },
  { name: 'Red', hex: '#f52222' },
  { name: 'Gray', hex: '#8e8e8e' }
];

  const printColors = [
    { name: 'Navy', hex: '#102d55' },
    { name: 'White', hex: '#ffffff' },
    { name: 'Gold', hex: '#e4b64b' },
    { name: 'Black', hex: '#171717' }
  ];

  const fonts = [
   { name: 'College Varsity', value: "'Graduate', serif" },
{ name: 'Bold Athletic', value: "'Anton', sans-serif" },
{ name: 'Clean Varsity', value: "'Bebas Neue', sans-serif" },
{ name: 'Fun Block', value: "'Bungee', sans-serif" },
  ];

  
  const shirtImages = JSON.parse(
  document.getElementById('mom-draft-youth-shirt-images').textContent
);

  document.querySelectorAll('[data-mom-draft-designer]').forEach((root) => {
    const uid = `md-${Math.random().toString(36).slice(2)}`;
    const form = document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    form.id = form.id || `${uid}-form`;
    form.enctype = 'multipart/form-data';

    let state = {
      shirt: 'White',
      text: '',
      font: fonts[0].value,
      print: '#102d55',
      image: null
    };

    root.innerHTML = `
      <div class="md-shell">
        <div class="md-header">
          <div class="md-eyebrow">Mom Draft Customs</div>
          <h2>Design your custom tee</h2>
          <p>Make it yours. We will review every order before printing.</p>
        </div>

        <div class="md-grid">
          <div class="md-preview">
            <div class="md-shirt">
              <img class="md-shirt-image" src="${shirtImages.White}" alt="White youth T-shirt preview">
              <div class="md-art">YOUR<br>DESIGN</div>
            </div>
          </div>

          <div class="md-controls">
            <h3>Create a front design</h3>
            <p>Your choices are saved with your order. For team orders, contact us first so we can set up your group storefront.</p>

            <div class="md-field">
              <label>Shirt color</label>
              <div class="md-swatches md-shirt-swatches"></div>
            </div>

            <div class="md-field">
              <label for="${uid}-text">Your wording</label>
              <input id="${uid}-text" type="text" maxlength="26" placeholder="Example: Baseball Mom">
            </div>

            <div class="md-field">
              <label for="${uid}-font">Font</label>
              <select id="${uid}-font"></select>
            </div>

            <div class="md-field">
              <label>Print color</label>
              <div class="md-swatches md-print-swatches"></div>
            </div>

            <div class="md-field">
              <label for="${uid}-upload">Add your logo or artwork</label>
              <input id="${uid}-upload" type="file"
                accept="image/png,image/jpeg"
                name="properties[Artwork upload]"
              <p class="md-note">PNG, JPG, or SVG. Transparent PNG is best. Use at least 1,800 px wide for a full-front print.</p>
              <p class="md-note md-warning" hidden></p>
            </div>

            <div class="md-approval">
              Artwork must be owned by you or used with permission. Low-resolution, trademarked, or unsafe artwork may need to be changed before we print.
            </div>
          </div>
        </div>
      </div>
    `;

    const preview = root.querySelector('.md-art');
    const shirtImage = root.querySelector('.md-shirt-image');
    const warning = root.querySelector('.md-warning');
    const upload = root.querySelector(`#${uid}-upload`);
    const textInput = root.querySelector(`#${uid}-text`);
    const fontSelect = root.querySelector(`#${uid}-font`);

    const setProperty = (name, value) => {
      let field = form.querySelector(`[data-md-property="${name}"]`);

      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = `properties[${name}]`;
        field.dataset.mdProperty = name;
        form.appendChild(field);
      }

      field.value = value;
    };

    const addSwatches = (container, options, type) => {
      container.innerHTML = '';

      options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'md-swatch';
        button.title = option.name;
        button.setAttribute('aria-label', option.name);
        button.dataset.type = type;
        button.dataset.name = option.name;
        button.dataset.hex = option.hex;
        button.style.background = option.hex;
        container.appendChild(button);
      });
    };

    fontSelect.innerHTML = fonts
      .map((font) => `<option value="${font.value}">${font.name}</option>`)
      .join('');

    addSwatches(root.querySelector('.md-shirt-swatches'), shirtColors, 'shirt');
    addSwatches(root.querySelector('.md-print-swatches'), printColors, 'print');

    const updateSelectedButtons = () => {
      root.querySelectorAll('.md-swatch').forEach((button) => {
        const selected =
          (button.dataset.type === 'shirt' && button.dataset.name === state.shirt) ||
          (button.dataset.type === 'print' && button.dataset.hex === state.print);

        button.setAttribute('aria-pressed', String(selected));
      });
    };

    const render = () => {
      shirtImage.src = shirtImages[state.shirt] || shirtImages.White;
shirtImage.alt = `${state.shirt} youth T-shirt preview`;

      preview.style.setProperty('--art-color', state.print);
      preview.style.setProperty('--art-font', state.font);

      if (state.image) {
        preview.innerHTML = '';
        const image = document.createElement('img');
        image.src = state.image;
        image.alt = 'Customer artwork preview';
        preview.appendChild(image);
      } else {
        preview.textContent = state.text || 'YOUR\nDESIGN';
      }

      setProperty(
        'Mom Draft Customization',
        JSON.stringify({
          shirtColor: state.shirt,
          wording: state.text || 'No wording entered',
          font: fonts.find((font) => font.value === state.font)?.name,
          printColor: printColors.find((color) => color.hex === state.print)?.name,
          printLocation: 'Front center'
        })
      );
setProperty('Shirt color', state.shirt);
setProperty('Custom wording', state.text || 'No wording entered');
setProperty('Font', fonts.find((font) => font.value === state.font)?.name || '');
setProperty('Print color', printColors.find((color) => color.hex === state.print)?.name || '');
setProperty('Print location', 'Front center');
      updateSelectedButtons();
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('.md-swatch');
      if (!button) return;

      if (button.dataset.type === 'shirt') state.shirt = button.dataset.name;
      if (button.dataset.type === 'print') state.print = button.dataset.hex;

      render();
    });
      const syncShopifyColor = (value) => {
  const match = shirtColors.find(
    (color) => color.name.toLowerCase() === String(value).toLowerCase()
  );

  if (!match) return;

  state.shirt = match.name;
  render();
};

document.addEventListener('change', (event) => {
  syncShopifyColor(event.target.value);
});

const selectedColorControl = Array.from(
  document.querySelectorAll('input:checked, select')
).find((control) =>
  shirtColors.some(
    (color) => color.name.toLowerCase() === String(control.value).toLowerCase()
  )
);

if (selectedColorControl) {
  syncShopifyColor(selectedColorControl.value);
}

    textInput.addEventListener('input', (event) => {
      state.text = event.target.value;
      state.image = null;
      render();
    });

    fontSelect.addEventListener('change', (event) => {
      state.font = event.target.value;
      render();
    });

    upload.addEventListener('change', () => {
      const file = upload.files && upload.files[0];
      if (!file) return;
      const maxSize = 10 * 1024 * 1024;

if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > maxSize) {
  warning.hidden = false;
  warning.textContent = 'Please upload a PNG or JPG under 10 MB.';
  upload.value = '';
  return;
}

      setProperty('Artwork filename', file.name);

      if (file.type === 'image/svg+xml') {
        warning.hidden = true;
        const reader = new FileReader();
        reader.onload = () => {
          state.image = reader.result;
          render();
        };
        reader.readAsDataURL(file);
        return;
      }

      const image = new Image();
      image.onload = () => {
        warning.hidden = image.width >= 1800;
        warning.textContent = warning.hidden
          ? ''
          : 'This image may print blurry. Please upload a file at least 1,800 px wide.';

        const reader = new FileReader();
        reader.onload = () => {
          state.image = reader.result;
          render();
        };
        reader.readAsDataURL(file);
      };

      image.src = URL.createObjectURL(file);
    });

    render();
        const addOrderDetail = (targetForm, name, value) => {
      let field = targetForm.querySelector(`[data-md-submit-property="${name}"]`);

      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = `properties[${name}]`;
        field.dataset.mdSubmitProperty = name;
        targetForm.appendChild(field);
      }

      field.value = value;
    };

    document.addEventListener(
      'submit',
      (event) => {
        const submittedForm = event.target;

        if (!submittedForm.matches('form[action*="/cart/add"]')) return;

        addOrderDetail(submittedForm, 'Shirt color', state.shirt);
        addOrderDetail(submittedForm, 'Custom wording', state.text || 'No wording entered');
        addOrderDetail(
          submittedForm,
          'Font',
          fonts.find((font) => font.value === state.font)?.name || ''
        );
        addOrderDetail(
          submittedForm,
          'Print color',
          printColors.find((color) => color.hex === state.print)?.name || ''
        );
        addOrderDetail(submittedForm, 'Print location', 'Front center');
        if (upload.files && upload.files.length > 0) {
  upload.removeAttribute('form');
  upload.name = 'properties[Artwork upload]';
  submittedForm.appendChild(upload);

  addOrderDetail(
    submittedForm,
    'Artwork filename',
    upload.files[0].name
  );
}
      },
      true
    );
  });
})();